export const minZoom = 0.1;
export const maxZoom = 3;
export const fitPadding = 20;
export const nodeRadius = 30;
export const nodeDistance = 150;
export const nodeRepulsion = 10;
export const centerForce = 0.05;
export const strokeWidth = 2;
export const fontSize = 12;
